import { node } from 'prop-types';
import { Icon, Tooltip } from '@chaser/components';
import styles from './InfoTooltip.module.scss';
import { Position } from '../Positioner';

const InfoTooltip = ({
  children = undefined,
  position = Position.LEFT,
  iconSize = 20,
  color,
  ...rest
}) => {
  return (
    <Tooltip contentClassName={styles.tooltip} content={children} position={position} {...rest}>
      <Icon className={styles.icon} name="info" color={color} size={iconSize} />
    </Tooltip>
  );
};

InfoTooltip.propTypes = {
  children: node,
};

export default InfoTooltip;
